import { createFileRoute } from '@tanstack/react-router'
import { PortalJobsScreen } from '../../features/portal/jobs'

export const Route = createFileRoute('/portal/')({
  component: PortalJobsScreen,
})
